import React from "react";
import {
  CardBody,

  Row,
  Col,
  ModalBody,
  ModalHeader
} from "reactstrap";
import { config } from "_constants";

// import { history } from '_helpers';

// import Datetime from "react-datetime";
import { connect } from 'react-redux';
// import { Redirect } from "react-router-dom";
// import * as moment from 'moment';
// import {
//   withScriptjs,
//   withGoogleMap,
//   GoogleMap,
//   Marker
// } from "react-google-maps";
          

class LiveNyteLaunchPartnerTerms extends React.Component {
  constructor(props) {
    super(props);
    console.log("LiveNyteLaunchPartnerTerms constructor()", props)
    this.state = {
    };
  }

  

  componentDidMount() {
  }

  
  render() {
    const {toggle} = this.props 
    return (
      <> 
      <ModalHeader className="text-left" toggle={toggle}>
        <h2>LiveNyte, Inc.<br/>Launch & Partner Program Terms of Participation</h2>
        <h3>Last updated: June 17, 2025<br/><br/>
        </h3>
          <h4 className="mt-2">
          These Launch & Partner Program Terms (“Program Terms”) are supplemental to the LiveNyte Terms of Service and apply to any individual or entity (“you”) who participates in LiveNyte's launch testing initiatives or partner programs (collectively, the “Programs”). 
          These Program Terms incorporate by reference the LiveNyte Terms of Service and Privacy Policy. In the event of a conflict, these Program Terms will govern as it relates to the Programs.
        </h4>
      </ModalHeader>
      <ModalBody  className="">
          <Row>
             
            <Col xs={12}>
              <div className="text-left pt-0 mt-0">
                <h4>1. Eligibility</h4>
                <p>Participation in the Programs is limited to individuals or entities who are 18 years of age or older and have the legal capacity to enter into binding agreements. You may be required to meet additional eligibility criteria specific to the Program as determined by LiveNyte in its sole discretion.</p>
                <br/><br/>

                <h4>2. Program Participation and Communications Consent</h4>
                <p>By enrolling or expressing interest in the Programs, you consent to receive marketing, operational, and transactional communications from LiveNyte via email, SMS, and other digital channels. Communications may include one-on-one messages or phone calls from LiveNyte team members as part of the partner onboarding process or for ongoing program coordination. Standard message and data rates may apply. You may opt out at any time by following the unsubscribe instructions or replying STOP to SMS messages.</p>
                <br/><br/>

                <h4>3. No Guarantee of Participation or Access</h4>
                <p>Enrollment in a Program does not guarantee access to any particular feature, benefit, opportunity, or future program. LiveNyte may accept, deny, modify, or terminate your participation at any time for any reason without notice.</p>
                <br/><br/>

                <h4>4. Program Changes and Termination</h4>
                <p>LiveNyte reserves the right to modify, suspend, or terminate any Program, including these Program Terms, at any time. Changes will become effective upon posting. Continued participation in the Programs following such changes constitutes acceptance.</p>
                <br/><br/>

                <h4>5. Data Collection and Privacy</h4>
                <p>Your participation in the Programs is subject to our  <a href={config.commonUrl + config.privacyLocalPath} target="_blank">Privacy Policy</a>. By participating, you agree that LiveNyte may collect and use your personal data in accordance with this policy.</p>
                <br/><br/>

                <h4>6. Feedback</h4>
                <p>If you provide any feedback, suggestions, or ideas regarding the Programs or Services ("Feedback"), you grant LiveNyte a worldwide, royalty-free, perpetual license to use and incorporate such Feedback for any purpose, commercial or otherwise, without acknowledgment or compensation.</p>
                <br/><br/>

                <h4>7. Indemnification</h4>
                <p>To the maximum extent permitted by law, you agree to indemnify, defend, and hold harmless LiveNyte, its affiliates, officers, agents, and employees from any claim, demand, loss, liability, or expense (including attorneys' fees) arising from your participation in the Programs, your breach of these Program Terms, or your misuse of the Services.</p>
                <br/><br/>

                <h4>8. Limitation of Liability</h4>
                <p>The Programs are provided "as is" and "as available" without warranties of any kind. LiveNyte makes no guarantees regarding Program availability or outcomes. To the fullest extent permitted by law, in no event shall LiveNyte be liable for any indirect, incidental, special, or consequential damages related to your participation. <strong>LiveNyte's total aggregate liability to you shall not exceed fifty U.S. dollars (US $50)</strong>, regardless of the cause of action or theory of liability, and even if advised of the possibility of such damages.</p>
                <br/><br/>

                <h4>9. Governing Law and Dispute Resolution</h4>
                <p>These Program Terms are governed by the laws of the State of California. Any disputes arising under or related to the Programs will be resolved through binding arbitration in San Francisco County, California, in accordance with the rules of the American Arbitration Association.</p>
                <br/><br/>

                <h4>10. Miscellaneous</h4>
                <p>These Program Terms are subject to the full <a href={config.commonUrl + config.termsLocalPath} target="_blank">LiveNyte Terms of Service</a> If any provision is found unenforceable, the remaining provisions will remain in effect.</p>
                <p>If you have questions about these Program Terms, please contact us at <a href="mailto:support@livenyte.com">support@livenyte.com</a>.</p>
                <br/><br/>
              </div>
            </Col>
          </Row>
        </ModalBody> 
      </>
    );
  }
}

function mapStateToProps(state) {
  return {

  };
}

const connectedLiveNyteLaunchPartnerTerms= connect(mapStateToProps)(LiveNyteLaunchPartnerTerms);
export { connectedLiveNyteLaunchPartnerTerms as LiveNyteLaunchPartnerTerms }; 